import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { FirebaseConfig } from '../types';

// Your Firebase configuration
// Replace with your actual Firebase config
const firebaseConfig: FirebaseConfig = {
  apiKey: "AIzaSyB5gx00eekonqLMAZN7QgM5zsLG-cy1Ydg",
  authDomain: "meconyapi-1.firebaseapp.com",
  projectId: "meconyapi-1",
  storageBucket: "meconyapi-1.firebasestorage.app",
  messagingSenderId: "826471716435",
  appId: "1:826471716435:web:f97e1b5fd19465c9f658a6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app; 